import { createRouter, createWebHistory } from 'vue-router';

// Views
import HomePage from '../views/HomePage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/select-risk',
    name: 'RiskSelection',
    component: () => import('@/views/RiskSelectionView.vue')
  },
  {
    path: '/portfolio',
    name: 'PortfolioForm',
    component: () => import('@/views/PortfolioForm.vue')
  },
  {
    path: '/compare',
    name: 'PerformanceCompare',
    component: () => import('../views/PerformanceCompare.vue'),
  },
  {
    path: '/next',
    name: 'ResultsNextSteps',
    component: () => import('../views/ResultsNextSteps.vue'),
  },
  {
    path: '/pro',
    name: 'SpeakToPro',
    // UPDATED: Now points to the specific component
    component: () => import('../views/SpeakToPro.vue'), 
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;